<template>
  <div class="thirdpary-container">
    <div class="img-cotainer">
      <div class="app-logo">
        <img src="~@/assets/image/icons/logo.png" alt="" />
      </div>
      <div class="login-gift">
        <p>註冊即可領取優惠券</p>
      </div>
      <div ref="valid">
        <div class="fb-login" ref="validFacebook" @click="jump2login('Facebook')">
          <img src="~@/assets/image/fps-icon/fb-logo.png" alt="">
          <p>Facebook 登入</p>
        </div>
        <div class="gg-login" ref="validGoogle" @click="jump2login('Google')">
          <img src="~@/assets/images/Google.png" alt="">
          <p>Google 登入</p>
        </div>
        <div class="line-login" ref="validLine" @click="jump2login('Line')">
          <img src="~@/assets/images/line-logo.png" alt="">
          <p>LINE 登入</p>
        </div>
      </div>
    </div>
    <div v-if="thirdparyLogining" class="thirdpary-logining" @click="thirdparyLogining = false">
      <i class="el-icon-loading" />
    </div>
  </div>
</template>
<script>
import { getInviterUuid } from '@/api'
import store from '@/store/index'

export default {
  name: 'Thirdpary',
  props: {
    isCommonLogin: {
      type: Boolean,
      default: false
    },
    pagelogin: {
      type: Boolean,
      default: false
    },
    isSaveToken: {
      type: Boolean,
      default: true
    },
    isBanner: {
      type: Boolean,
      default: false
    },
    isHome: {
      type: Boolean,
      default: false
    },
    redirectPath: {
      type: String,
      default: ''
    },
    isClickOrder: {
      type: Boolean,
      default: false
    },
    chatAvatar: {
      type: String,
      default: ''
    },
    inviterUuid:String
  },
  data() {
    return {
      thirdparys: ['Facebook', 'Google', 'Line'],
      thirdparyLogining: false,
      thirdLoginType: ''
    }
  },
  watch: {
    thirdparyLogining (value) {
      if (value) {
        document.body.style.overflow = "hidden"
      } else {
        document.body.style.overflow = "auto"
      }
    }
  },
  created() {
    this.providers = {}
    this.checkLineLogin()
    this.addFacebookLogin()
  },
  methods: {
    phoneLogin() {
      this.$emit('phoneLogin')
    },
    addFacebookLogin() {
      if (window.sessionStorage.getItem('isFacebookAppLogin')) {
        window.sessionStorage.removeItem('isFacebookAppLogin')
        this.thirdparyLogining = true
        const name = window.sessionStorage.getItem('loginPath')
        window.firebaseRedirectResultFn({
          resolve: this.firebaseAuthThen.bind(this, name),
          reject: this.firebaseAuthCatch.bind(this, name)
        })
        return
      }
    },
    checkLineLogin() {
      let objStr = sessionStorage.getItem('lineParams')
      if (objStr) {
        sessionStorage.removeItem('lineParams')
        this.thirdparyLogining = true
        this.$http.post('/login/line/token', {
          grant_type: 'authorization_code',
          callback_url: location.origin,
          code: objStr
        }).then(rs => {
          // window.gtag('AuthSuccess', 'ThirdPartyLogin')
          let lineToken = rs.data.id_token
          let inviterUnique = window.localStorage.getItem('STORAGE_INVITER_UUID') || null
          if (!inviterUnique) {
            const str = sessionStorage.getItem('INVITE_UNIQUE')
            str && (inviterUnique = JSON.parse(str).inviterUnique)
          }
          this.$http.post('/login/line/login2', {
            lineToken,
            loginChannelKind: 'Line',
            inviterUnique:this.inviterUuid || inviterUnique,
            signUpUniqueCode: sessionStorage.getItem('signUpUniqueCode')
          }).then(rs => {
            this.thirdparyLogining = false
            store.dispatch('app/changeUserInfo', {
              data: rs.data,
              isSaveToken: this.isSaveToken
            })
            if (rs.data.isNewRegistration) {
              // 当新用户存在邀请人时，查看邀请人信息并用于埋点
              this.$adjust('web_activate_success', {type: 'line'})
              this.reportInviterInfo(rs.data.uuid)
          
              // window.gtag('Request', 'register', rs.data.uuid)
              // window.gtag('RegisterSuccess', 'ThirdPartyLogin')
              // window.gtag('signupab_success', unLoginAB)
              this.$nextTick(() => {
                this.$emit('closeLogin')
                // store.dispatch('master/guideSelect', true)
              })
              this.$adjust('login_page_btn_click', {
                source: 'line'
              })
              // BindPhone({
              //   isBanner: this.isBanner,
              //   isHome: this.isHome,
              //   pagelogin: this.pagelogin,
              //   redirectPath: this.redirectPath,
              //   isClickOrder: this.isClickOrder
              // })
            } else {
              // window.gtag('LoginSuccess', 'ThirdPartyLogin')
              // window.gtag('request', 'signin', rs.data.uuid)
              this.$adjust('login_success', {
                source: 'line'
              })
              this.success1(true)
              if (!this.pagelogin) {
                this.$emit('closeLogin')
              } else {
                this.$emit('jump_redirect')
              }
            }
          }).catch(rs => {
            this.thirdparyLogining = false
            this.$message.error(rs.msg)
          })
        }).catch(rs => {
          this.thirdparyLogining = false
          // window.gtag('AuthFail', 'ThirdPartyLogin')
          // location.href = sessionStorage.getItem('beforeJump2LoginLine')
          this.$message.error(rs.msg)
        })
      }
    },
    getState() {
      let nums = Math.floor(Math.random() * 7 + 10)
      let rs = ''
      for(let i = 0; i < nums; i++) {
        rs += Math.floor(Math.random() * 36).toString(36)
      }
      window.sessionStorage.setItem('LineState', rs)
      return rs
    },
    /* 新三方用戶註冊 */
    success1(isLogin) {
      this.$emit('ThirdparyLoginSuccess', {
        isLogin,
        isThirdpary: true
      })
    },
    reportInviterInfo(uuid) {
      try {
        getInviterUuid({ uuid }).then(({data})=>{
          let inviterUnique = ''
          const str = sessionStorage.getItem('INVITE_UNIQUE')
          str && (inviterUnique = JSON.parse(str).inviterUnique)
          this.$adjust('web_blac_catch', {
            localUnique: window.localStorage.getItem('CURRENT_UNIQUE'),
            inviterUnique:this.inviterUuid || inviterUnique,
            inviteNum: window.localStorage.getItem('REGISTER_NUM_' + inviterUnique),
            inviterUuid: data && data.invitedUuid ? data.invitedUuid : 0,
            current_uuid: uuid
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async jump2login(name) {
      if (this.isAuthing) return
      this.isAuthing = true
      // const validRes = await this.validPerson(name)
      // if(!validRes) {
      //   this.isAuthing = false
      //   return
      // }
      // window.gtag('Click', 'ThirdPartyLogin')
      // unLoginAB = window.localStorage.getItem('unLoginHomeABTest')
      if (!this.providers[name]) {
        switch(name) {
          case 'Facebook': {
            this.thirdLoginType = 'fb'
            this.$adjust('login_page_btn_click', {
              source: 'facebook'
            })
            this.providers[name] = new window.firebase.auth.FacebookAuthProvider()
            break
          }
          case 'Google': {
            this.thirdLoginType = 'google'
            this.$adjust('login_page_btn_click', {
              source: 'google'
            })
            this.providers[name] = new window.firebase.auth.GoogleAuthProvider()
            break
          }
          case 'Line': {
            this.thirdLoginType = 'line'
            this.$adjust('login_page_btn_click', {
              source: 'line'
            })
            window.sessionStorage.setItem('beforeJump2LoginLine', location.href)
            if (!this.pagelogin) {
              window.sessionStorage.setItem('openLogin', 1)
            }
            location.href = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${window.lineChannelId}&redirect_uri=${encodeURIComponent(location.origin)}&scope=openid%20profile&state=${this.getState()}`
            return
          }
        }
      }
      if (window.shouldRedirect()) {
        window.sessionStorage.setItem('beforeJump2LoginFirebase', location.href)
        window.sessionStorage.setItem('isFacebookAppLogin', 1)
        window.sessionStorage.setItem('loginPath', name)
        window.firebase.auth().signInWithRedirect(this.providers[name])
        return
      }
      this.thirdparyLogining = true
      window.firebase.auth().signInWithPopup(this.providers[name])
        // .then((rs)=>{this.firebaseAuthThen(name, rs, validRes)})
        .then((rs)=>{this.firebaseAuthThen(name, rs)})
        .catch(this.firebaseAuthCatch.bind(this, name))
    },
    firebaseAuthCatch() {
      this.thirdparyLogining = false
      this.isAuthing = false
      // window.gtag('AuthFail', 'ThirdPartyLogin')
      this.$message.error('認證失敗')
    },
    firebaseAuthThen(name, rs, validRes = {}) {
      if (rs.user) {
        // window.gtag('AuthSuccess', 'ThirdPartyLogin')
        let token = rs.user._lat
        let inviterUnique = window.localStorage.getItem('STORAGE_INVITER_UUID') || null
        if (!inviterUnique) {
          const str = sessionStorage.getItem('INVITE_UNIQUE')
          str && (inviterUnique = JSON.parse(str).inviterUnique)
        }
        this.$http.post('/login/firebase/login2', {
          firebasetoken: token,
          loginChannelKind: name,
          inviterUnique:this.inviterUuid || inviterUnique,
          signUpUniqueCode: this.$route.params.inviteCode,
          // ticket: validRes.ticket,
          // rand: validRes.randstr
        }).then(loginRs => {
          if (loginRs.data.userDeleteStatus === "DeleteReady") {
            this.thirdparyLogining = false
            this.isAuthing = false
            this.$confirm({
              content: '該賬戶註銷中，若希望完成註銷，請在15日內不要登錄此賬號。點擊「確認」將登陸此賬號，並撤回註銷申請。',
              confirmButtonText: '確認',
            }).then(()=>{
              this.$http.get('/user/delete/cancel', { uuid: loginRs.data.uuid }).then(()=>{
                setTimeout(() => {
                  this.firebaseAuthThen(name, rs)
                 }, 500);
              })
            }).catch(()=>{
            })
            return
          } 
          this.thirdparyLogining = false
          this.isAuthing = false
          store.dispatch('app/changeUserInfo', {
            data: loginRs.data,
            isSaveToken: this.isSaveToken
          })
          if (loginRs.data.isNewRegistration) {
            this.$adjust('web_activate_success', {type: name})
            this.reportInviterInfo(loginRs.data.uuid)
            window.fbq('track', 'CompleteRegistration')
            window.fbq('track', 'Lead')
            // window.gtag('Request', 'register', loginRs.data.uuid)
            // window.gtag('RegisterSuccess', 'ThirdPartyLogin')
            // window.gtag('signupab_success', unLoginAB)
            this.$adjust('login_page_btn_click', {
              source: name.toLowerCase()
            })
            this.$nextTick(() => {
              this.$emit('closeLogin')
              // store.dispatch('master/guideSelect', true)
            })
            // BindPhone({
            //   isBanner: this.isBanner,
            //   isHome: this.isHome,
            //   pagelogin: this.pagelogin,
            //   redirectPath: this.redirectPath,
            //   isClickOrder: this.isClickOrder
            // })
          } else {
            console.log(loginRs.data)
            // window.gtag('LoginSuccess', 'ThirdPartyLogin')
            // window.gtag('request', 'signin', loginRs.data.uuid)
            if (this.thirdLoginType) {
              // gtag(`signupab_${this.thirdLoginType}_success`, unLoginAB)
            }
            this.$adjust('login_success', {
              source: name.toLowerCase()
            })
            if (!this.pagelogin) {
              this.$emit('closeLogin')
            } else {
              this.$emit('jump_redirect')
            }
            this.success1(true)
          } 
        }).catch((e) => {
          console.error(e)
          this.thirdparyLogining = false
          this.isAuthing = false
          this.$message.error('認證失敗')
        })
      }
    },
    validPerson() {
      return new Promise((resolve)=>{
        new window.TencentCaptcha(
          this.$refs.valid,
          process.env.VUE_APP_VERIFICATION_APPID,
          resp => {
            if(resp.ret === 0) {
              resolve(resp)
            } else {
              resolve(0)
            }
          })
      })
      
    }
  }
}
</script>
<style lang="scss" scoped>
.thirdpary-logining {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, .3);
  color: #FFFFFF;
  z-index: 9999;
  font-size: 36px;
}
.thirdpary-button {
  box-shadow: 0px 0.8px 3px rgba(0, 0, 0, 0.08);
  transition: all .25s;
  &:hover {
    box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.1);
  }
}
.mobile-prefix-inner span {
  color: #333;
  font-weight: 500;
}
.thirdpary-container {
  margin: 0 auto;
  width: 290px;
}
.thirdpary-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  .thirdpary-line {
    flex: 1;
    height: 1px;
    background: rgba(204, 204, 204, 0.6);
  }
  .tip-content {
    margin: 0 24px;
    color: #CCC;
    font-size: 13px;
  }
}
.img-cotainer {
   display: flex;
      flex-direction: column;
      align-items: center;
  // img {
  //   border-radius: 50%;
  //   width: 62px;
  //   height: 62px;
  // }
  .master-chat {
    display: flex;
    width: 280px;
    margin-bottom: 25px;
    align-items: flex-end;
    .img {
      width: 58px;
      height: 58px;
      margin-right: 7px;
    }
    p {
      flex: 1;
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
      border-radius: 15px 15px 15px 2.5px;
      padding: 8px 12px;
      background: rgba(62, 69, 87, .1);
      line-height: 22px;
      font-size: 14px;
    }
  }
  .app-logo {
    height: 42.9px;
    font-size: 68px;
    @include flex;
    color: $color-gray-1;
    img {
      height: 29px;
    }
  }
  .login-gift {
    margin-top: 23px;
    font-weight: 500;
    font-size: 15px;
    line-height: 21px;
    color: $color-gray-1;
  }
  .fb-login {
    display: flex;
    width: 280px;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    align-items: center;
    background: #3D78EB;
    box-shadow: 0px 0.8px 4px rgba(0, 0, 0, 0.15);
    border-radius: 30px;
    justify-content: center;
    margin-top: 59px;
    p {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 15px;
      text-align: center;
      color: #FFFFFF;
    }
    img {
      width: 35px;
      margin-right: 5px;
      height: 35px;
    }
  }
  .line-login {
    display: flex;
    width: 280px;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    align-items: center;
    background: #00B900;
    box-shadow: 0px 0.8px 4px rgba(0, 0, 0, 0.15);
    border-radius: 30px;
    justify-content: center;
    margin-top: 15px;
    p {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 15px;
      text-align: center;
      color: #FFFFFF;
    }
    img {
      width: 35px;
      margin-right: 5px;
      height: 35px;
    }
  }  
  .gg-login {
    display: flex;
    width: 280px;
    height: 48px;
    line-height: 48px;
    align-items: center;
    background: #FFFFFF;
    box-shadow: 0px 0.8px 4px rgba(0, 0, 0, 0.15);
    border-radius: 30px;
    cursor: pointer;
    justify-content: center;
    margin-top: 15px;
    p {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 15px;
      text-align: center;
      color:  #333333;
    }
    img {
      width: 35px;
      margin-right: 5px;
      height: 35px;
    }
  }

}


@media screen and (max-width: 599px) {

  .thirdpary-container {
    width: 76vw;
    max-width: 290px;
  } 
}
</style>
